module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/zh-hans_2-0c1a65beb9a092d4a08a65004b3c12d5.jpg";